import TopTicker from "@/components/layout/TopTicker";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import EmailDiscountPopup from "@/components/EmailDiscountPopup";
import CartDrawer from "@/components/CartDrawer";
import MobileDrawer from "@/components/layout/MobileDrawer";
import { UiChromeProvider, useUiChrome } from "@/context/UiChromeContext";

function LayoutInner({ children }) {
  const { drawerOpen, closeDrawer } = useUiChrome();
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <TopTicker />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <EmailDiscountPopup />
      <CartDrawer />
      <MobileDrawer open={drawerOpen} onClose={closeDrawer} />
    </div>
  );
}

export default function Layout({ children }) {
  return (
    <UiChromeProvider>
      <LayoutInner>{children}</LayoutInner>
    </UiChromeProvider>
  );
}
